import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/visitador_medico/linea_promocional';
import LineaPromocional from './LineaPromocional';


const ms2p = (state) => {
  return {
    ...state.vm_linea_promocional,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(LineaPromocional);

